function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.99 4.51V.722c.023-.193-.031-.385-.183-.533-.264-.25-.692-.25-.956 0L.192 7.228c-.14.135-.2.308-.191.488-.01.174.05.353.191.488L6.814 15.2c.123.148.3.244.508.244.19 0 .358-.077.48-.199 0 0 .003 0 .005-.006.152-.141.206-.34.183-.527L8 10.928c4.4 0 8.379 3.05 9.168 7.072.532-1.182.831-2.48.831-3.848 0-5.325-4.482-9.641-10.01-9.641m.678 5.132c-.436 0-2.013.013-2.013.013v3.45L1.55 7.715 6.655 2.32v3.476s1.666-.02 2.013-.007c4.707.141 7.976 5.306 7.998 7.721-1.44-1.78-5.219-3.867-7.998-3.867",
  transform: "translate(-377 -1047) translate(0 1032) translate(241) translate(84.5 13) translate(52 2) matrix(-1 0 0 1 18 0)"
})))))));

var SvgIcShare = function SvgIcShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_share.e752a312.svg";
export { ForwardRef as ReactComponent };